import { Button, Grid, InputAdornment } from '@mui/material'
import React, { FC, useState } from 'react'
import { FeeType } from '../../../../api/models/Common/JyrneyEnums'
import FormInput from '../../../FormFields/FormInput/FormInput'
import FormSelect from '../../../FormFields/Select/FormSelect'
import ChargeExceptionSelect from './ChargeExceptionSelect'

export const getAdornmentProps = (value: string) => {
  if (value === 'Fixed') {
    return {
      startAdornment: <InputAdornment position="start">£</InputAdornment>,
    }
  }
  if (value === 'Percentage') {
    return { endAdornment: <InputAdornment position="end">%</InputAdornment> }
  }
}

interface ChargeExceptionProps {
  namePrefix?: string
  handleOnSave: () => void
}
const ChargeExceptionPattern: FC<ChargeExceptionProps> = (props) => {
  const { namePrefix = 'chargeException', handleOnSave } = props
  const [chargeTypeName, setChargeTypeName] = useState('')
  return (
    <>
      <Grid item xs={6}>
        <ChargeExceptionSelect
          name={`${namePrefix}.chargeExceptionId`}
          label="Charge exception"
        />
      </Grid>
      <Grid item xs={6}>
        <FormSelect
          name={`${namePrefix}.chargeTypeName`}
          label="Fee type"
          options={FeeType}
          onChange={(e) => {
            setChargeTypeName(e.target.value)
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <FormInput
          name={`${namePrefix}.value`}
          label="Value"
          InputProps={getAdornmentProps(chargeTypeName)}
        />
      </Grid>
      <Grid item xs={6}>
        <Button
          type="submit"
          variant="outlined"
          onClick={(e) => {
            e.preventDefault()
            handleOnSave()
          }}
        >
          Save exception
        </Button>
      </Grid>
    </>
  )
}

export default ChargeExceptionPattern
